// extracted by mini-css-extract-plugin
export default {"resume":"Resume_resume__F-wi0","self-info":"Resume_self-info__WiQyD"};